import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@src/app/shared/services/session.service';
import { LoginNavigationService } from '@src/app/shared/services/loginNavigation.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss',
    host: {
        class: 'app-page-not-found'
    },
    standalone: false
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private router: Router,
    private sessionService: SessionService,
    private loginNavigationService : LoginNavigationService
  ) { }

  ngOnInit() { }

  async backToMainPage() {
    const isAuthenticated = await this.sessionService.isLogged();

    if (!isAuthenticated) {
      this.router.navigate(['/login']);
      return;
    }

    const path = await this.loginNavigationService.resolveLandingPage();
    await this.loginNavigationService.navigateLandingPage(path);
  }
}
